/**
 * @file widgets.js
 * @project Web-panel
 * @author Pavel Shabardin (<bigbn@mail.ru>) Wednesday, 17th February 2021 10:25:13 am
 * @copyright 2015 - 2021 SKAT LLC, Delive LLC
 * @flow
 */

import * as React from 'react'
import cn from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

type ColProps = {|
  children: React.Node
|}

const Col = ({ children }: ColProps) : React.Node => (
  <div className='widget-col'>{children}</div>
)

type RowProps = {|
  children: React.ChildrenArray<React.Element<typeof Col>>
|}

const Row = ({ children }: RowProps) : React.Node => (
  <div className='widget-row'>{children}</div>
)

type IconProps = {|
  icon : {},
  inverted?: true,
  spin?: true,
  standalone?: true
|}

const Icon = ({ icon, inverted, standalone, spin }: IconProps) : React.Node => (
  <FontAwesomeIcon className={cn('widget-icon', { inverted, standalone, spin })} icon={icon} />
)

type LabelProps = {|
  inverted?: true,
  standalone?: true,
  children?: string
|}

const Label = ({ children, inverted, standalone }: LabelProps) : React.Node => (
  <div className={cn('widget-label', { inverted, standalone })}>{children}</div>
)

type ActionProps = {|
  children: React.ChildrenArray<React.Element<typeof Icon| typeof Label>>,
  spin?: true,
  inverted?: true,
  standalone?: true
|}

const Action = ({ children, inverted, standalone, spin }: ActionProps) : React.Node => (
  <div className={cn('widget-action', { inverted, standalone, spin })}>{children}</div>
)

type InputProps = {|
  children?: React.ChildrenArray<React.Element<typeof Action> | React.Element<typeof Icon>>,
  standalone?: true
|}

const Input = ({ children } : InputProps) : React.Node => (
  <div className='widget-input'>
    <input type='text' />
    {children}
  </div>
)

export { Row, Col, Icon, Label, Action, Input }
